import React, { FunctionComponent } from 'react';
import { Icon, IconSize, Paragraph } from '@vwfs-bronson/bronson-react';
import { format } from 'date-fns';

interface MessageProps {
  author: string;
  message: string;
  time: Date;
  userRole: MilesPosNotesIntegrationService.Components.Schemas.ParticipantType;
  isCurrentUser: boolean;
  messageType?: 'SYSTEM_MESSAGE' | 'TEXT_MESSAGE';
}

interface MessageHeaderProps {
  author: string;
  time: Date;
  isDealer: boolean;
  isSystemMessage?: boolean;
}

const formatTimeElement = (time: Date) => (
  <time className="u-text-bolden u-font-size-fs-1" dateTime={time.toISOString()}>
    {format(time, 'dd.MM.yyyy, HH:mm')}
  </time>
);

const MessageHeader: FunctionComponent<MessageHeaderProps> = ({ author, time, isDealer, isSystemMessage }) => {
  let Tag: 'i' | 'b' | 'span' = 'span';

  if (isSystemMessage) {
    Tag = 'i';
  } else if (isDealer) {
    Tag = 'b';
  }

  return (
    <Tag className="u-font-size-fs-1">
      {author},&nbsp;
      {formatTimeElement(time)}
    </Tag>
  );
};

export const ChatMessage: FunctionComponent<MessageProps & { showHeader?: boolean }> = ({
  author,
  message,
  time,
  showHeader = true,
  isCurrentUser,
  userRole,
  messageType = 'TEXT_MESSAGE',
}) => {
  const isSystemMessage = messageType === 'SYSTEM_MESSAGE';

  let iconName = 'semantic-chat';
  let iconSize = IconSize.SMALL;

  if (isSystemMessage) {
    iconName = 'gear';
    iconSize = IconSize.XSMALL;
  } else if (userRole === 'FRONT_OFFICE') {
    iconName = 'semantic-user';
  }

  return (
    <article className={`u-mb-xsmall ${isCurrentUser ? 'u-text-right' : 'u-text-left'}`}>
      {showHeader && (
        <MessageHeader
          author={author}
          time={time}
          isDealer={userRole === 'FRONT_OFFICE'}
          isSystemMessage={isSystemMessage}
        />
      )}
      <div>
        <div
          className={`${isSystemMessage ? 'u-p-xsmall' : 'u-p-xsmall u-bg-alternative '}`}
          style={{ display: 'inline-flex', alignItems: 'center', borderRadius: '8px' }}
        >
          {!isCurrentUser && <Icon className="u-mr-xsmall" size={iconSize} name={iconName} />}

          <Paragraph className={`u-mb-none ${isSystemMessage ? 'u-text-muted u-font-size-fs-1' : ''}`}>
            {message}
          </Paragraph>

          {isCurrentUser && <Icon className="u-ml-xsmall" size={iconSize} name={iconName} />}
        </div>
      </div>
    </article>
  );
};
